import { gql } from "@apollo/client";
import EmployerFields from "../fragments/employer-fragment";

export default gql`
  mutation verifyEmployer($data: EmployerInput!) {
    verifyEmployer(data: $data) {
      ...EmployerFields
    }
  }
  ${EmployerFields}
`;
